import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./blockADecouvrir.scss"
import nosChambres from "./nosChambres.png"
import decouverte from "./decouverte.png"
import faiteLaDiff from "./faiteLaDiff.png"
import { graphql, Link } from "gatsby";
import Heading from "../heading";
import Media from "../media";
import HTMLReactParser from "html-react-parser";

const BlkADecouvrir = ({ content }) => {

  return (
    <section className="blk-aDecouvrir">
      <Container>
        <Heading title={content.block_read_more_title} heading={2} />
        <Row>
          {content.relationships.block_read_more_items.map((item, index) => (
            <Col md={4} xs={12} key={index}>
              <Link to={item.read_more_item_link.url} className="contenuADecouvrir">
                <Media media={item.relationships.read_more_item_media} />
                <Heading title={item.read_more_item_title} heading={3} description={HTMLReactParser(item.read_more_item_description.processed)} />
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment blockReadMore on paragraph__block_read_more {
    internal {
        type
    }
    block_read_more_title
    relationships {
      block_read_more_items {
        read_more_item_title
        read_more_item_link {
          title
          url
        }
        read_more_item_description {
          processed
        }
        relationships {
          read_more_item_media {
            relationships {
              ...getImage
            }
          }
        }
      }
    }
  }
`

export default BlkADecouvrir